import React from "react";
import { Label } from "recharts";
import styles from "./style.module.scss";

interface IProps {
  checked: boolean;
  setCheckBox: (checked: boolean) => void;
  onClick: () => void;
  disabled?: boolean;
  hrefTarget?: string;
  hrefLink?: string;
  hrefText?: string;
  label?: string;
  text: string;
}

const Checkbox = ({
  checked,
  setCheckBox,
  onClick,
  disabled,
  hrefTarget,
  hrefLink,
  hrefText,
  label,
  text,
}: IProps) => {
  return (
    <div className={styles.customCheckbox}>
      <label className={styles.label}>
        <div className="customCheckbox__label__first">
          {checked && <div className={styles.checked} />}
        </div>

        <input
          disabled={disabled}
          type="checkbox"
          onClick={onClick}
          onChange={() => {
            setCheckBox(!checked);
          }}
        />
      </label>

      <span className={styles.spanFirst}>
      <a target={hrefTarget} href={hrefLink}> {hrefText}</a> {label}
      </span>
     
      <span className={styles.spanFirst}>{text}</span>
    </div>
  );
};

export default Checkbox;
